const Background = (props) => {
  const { mix, index, activeIndex, image } = props;

  return (
    <div
      className={`home__background-wrapper ${
        activeIndex === index ? "active" : ""
      } ${mix._type === "editorsLetter" ? "home__el" : ""}`}
      style={{
        backgroundImage: mix._type === "mix" ? `url(${image})` : "",
      }}
    >
      <div className="home__color" />
    </div>
  );
};

export default Background;
